<template>
    <a-modal v-model="visible" :title="pageData.name" width="1000px"
             :centered="true"
             :destroyOnClose="true"
             :footer="null" @cancel="onCancel">
        <!--        图片预览-->
        <div class="imageView" v-if="pageData.fileType === 2" style="width:100%;height: 500px;">
            <a-spin :spinning="loading">
                <img :src="src" style="width:100%;object-fit: contain;height: 500px;">
            </a-spin>
        </div>
        <!--        音频预览-->
        <my-audio v-if="pageData.fileType === 3" :src="src"></my-audio>
        <!--        视频预览-->
        <div id="videoPlayer" v-if="pageData.fileType === 4"></div>
    </a-modal>
</template>

<script>
import MyAudio from "@/components/audio/index"
import Api from '@/requests/apis'

export default {
    name: "ResourcesFolderView",
    components: {MyAudio},
    props: {
        resources: {
            type: Object,
            required: true
        },
        visible: Boolean
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    data() {
        return {
            pageData: {},
            loading: true,
            src: null,
            AliPlayer: null,
        }
    },
    mounted() {
        console.log(this.resources);
        const baseURL = process.env.VUE_APP_API_BASE_URL;
        if (!(this.resources.fileResourceId || this.resources.id)) {
            return
        }
        if (!this.resources.fileType) {
            this.resources.fileType = this.resources.materialType;
        }
        if (!this.resources.fileResourceId) {
            this.resources.fileResourceId = this.resources.id;
        }
        this.pageData = this.resources;
        if (this.resources.fileType === 1) {
            this.$emit('change', false);
        }
        if (this.resources.fileType === 3) {
            this.src = baseURL + Api.Content.downloadFileStream + '?id=' + this.resources.fileResourceId;
        }
        this.$nextTick(() => {
            if (this.resources.fileType === 1) {
                const Params = {
                    materialId: this.resources.fileResourceId,
                };
                this.loading = true;
                this.$http.resourcesList.GeneratePresignedUri(Params).then(res => {
                    const {status, data, message} = res;
                        window.open(data)
                  
                }).finally(() => {
                  this.loading = false;
                })
            }
            if (this.resources.fileType === 2) {
                this.loading = true;
                const xhr = new XMLHttpRequest();
                xhr.open('GET', baseURL + Api.Content.downloadFileStream + '?id=' + this.resources.fileResourceId, true);
                xhr.responseType = 'blob';
                xhr.setRequestHeader("Authorization", "Bearer " + this.$store.getters["account/token"]());
                xhr.send(null);
                xhr.onload = () => {
                    this.loading = false;
                    this.src = window.URL.createObjectURL(xhr.response);
                };
            }
            if (this.resources.fileType === 4) {
                this.loading = true
                const params = {id: this.resources.fileResourceId};
                this.$http.FileResource.getVideoPlayAuth(params).then(res => {
                    const {status, data, message} = res;
            
                        this.AliPlayer = new Aliplayer(
                            {
                                id: 'videoPlayer',
                                width: '100%',
                                height: '500px',
                                autoplay: true,
                                vid: data.videoId,
                                playauth: data.playAuth,
                            },
                            function (player) {
                                player.play()
                            }
                        );
                   
                }).finally(() => {
                  this.loading = false
                })
            }
        });
    },
    methods: {
        onCancel() {
            this.$emit('change', false);
            if (this.AliPlayer) {
                this.AliPlayer.pause()
                this.AliPlayer.dispose()
                this.AliPlayer = null
            }
        }
    }
}
</script>

<style lang="less" scoped>
.head-breadcrumb {
    display: flex;
    margin-bottom: 15px;

    span:not(:last-child) {
        cursor: pointer;

        &:hover {
            color: #666;
        }

    }
}

.icon {
    width: 14px;
    height: 14px;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
    margin-right: 5px;
    flex-shrink: 0;
}

.table-name {
    display: flex;
    align-items: center;

    .ant-btn, span {
        display: inline-block;
        padding: 0;
        max-width: 200px;
        height: 23px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

}
</style>
